export const blogPosts = [
  {
    slug: 'pandabuy-spreadsheet-ultimate-guide-2026',
    title: 'The Ultimate Pandabuy Spreadsheet Guide 2026',
    excerpt: 'Everything you need to know about using pandabuyspreadsheet to find the best items for your next haul.',
    date: 'June 15, 2026',
    readTime: '8 min read',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20laptop%20displaying%20spreadsheet%20fashion%20magazine%20and%20coffee%20cup%20on%20cream%20wooden%20desk%20soft%20natural%20lighting%20warm%20neutral%20tones%20editorial%20photography%20clean%20aesthetic%20organized%20workspace&width=800&height=500&seq=blog-thumb-guide-2026&orientation=landscape',
    tag: 'Ultimate Guide',
    featured: true,
  },
  {
    slug: 'best-pandabuy-spreadsheet-shoes-2026',
    title: 'Best Pandabuy Spreadsheet Shoes 2026',
    excerpt: 'Discover the top sneaker picks from the pandabuyspreadsheet this year. From dunks to Jordans, find verified quality footwear links.',
    date: 'June 20, 2026',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20designer%20sneaker%20collection%20displayed%20on%20modern%20white%20floating%20shelves%20various%20basketball%20shoes%20lifestyle%20footwear%20warm%20ambient%20lighting%20editorial%20retail%20photography%20warm%20neutral%20cream%20tones%20clean%20minimal%20composition&width=800&height=500&seq=blog-thumb-shoes-2026&orientation=landscape',
    tag: 'Shoes',
    featured: false,
  },
  {
    slug: 'luxury-pandabuy-spreadsheet-finds',
    title: 'Luxury Pandabuy Spreadsheet Finds Guide',
    excerpt: 'Explore high-end watches, bags, and jewelry curated from the pandabuy spreadsheet. Verified luxury finds at accessible prices.',
    date: 'June 22, 2026',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20fashion%20accessories%20display%20with%20designer%20handbag%20gold%20wristwatch%20and%20pearl%20jewelry%20arranged%20on%20velvet%20surface%20warm%20studio%20lighting%20elegant%20editorial%20photography%20rich%20warm%20neutral%20tones%20sophisticated%20composition%20high%20detail&width=800&height=500&seq=blog-thumb-luxury-2026&orientation=landscape',
    tag: 'Luxury',
    featured: false,
  },
  {
    slug: 'budget-pandabuy-spreadsheet-under-50',
    title: 'Budget Pandabuy Spreadsheet Under $50',
    excerpt: 'Quality does not have to break the bank. Our top budget picks from the pandabuyspreadsheet all priced under fifty dollars.',
    date: 'June 25, 2026',
    readTime: '4 min read',
    image: 'https://readdy.ai/api/search-image?query=Affordable%20trendy%20fashion%20basics%20including%20plain%20t-shirts%20socks%20and%20simple%20accessories%20on%20light%20wooden%20surface%20clean%20budget%20shopping%20photography%20warm%20natural%20lighting%20neutral%20cream%20tones%20minimal%20composition%20value%20fashion%20aesthetic&width=800&height=500&seq=blog-thumb-budget-2026&orientation=landscape',
    tag: 'Budget',
    featured: false,
  },
  {
    slug: 'nike-shoes-pandabuy-spreadsheet-collection',
    title: 'Nike Shoes Pandabuy Spreadsheet Collection',
    excerpt: 'A deep dive into Nike offerings on the pandabuy spreadsheet. Dunks, Air Force, Jordan models and more verified links.',
    date: 'June 28, 2026',
    readTime: '7 min read',
    image: 'https://readdy.ai/api/search-image?query=Nike%20sneaker%20collection%20featuring%20Air%20Force%20and%20Dunk%20models%20displayed%20on%20clean%20white%20retail%20shelves%20modern%20sneakerhead%20room%20warm%20natural%20lighting%20editorial%20photography%20warm%20neutral%20tones%20athletic%20footwear%20focus%20premium%20quality&width=800&height=500&seq=blog-thumb-nike-2026&orientation=landscape',
    tag: 'Nike',
    featured: false,
  },
  {
    slug: 'hoodies-streetwear-pandabuy-spreadsheet',
    title: 'Hoodies & Streetwear Pandabuy Spreadsheet',
    excerpt: 'The best streetwear hoodies, Trapstar, Essentials, and tech fleece finds from the pandabuyspreadsheet community.',
    date: 'July 1, 2026',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=Premium%20streetwear%20hoodies%20collection%20in%20earth%20tones%20and%20neutral%20colors%20displayed%20on%20minimalist%20clothing%20rack%20warm%20natural%20lighting%20fashion%20editorial%20photography%20warm%20cream%20background%20urban%20aesthetic%20fabric%20texture%20detail&width=800&height=500&seq=blog-thumb-hoodies-2026&orientation=landscape',
    tag: 'Streetwear',
    featured: false,
  },
  {
    slug: 'viral-tiktok-pandabuy-spreadsheet-finds',
    title: 'Viral TikTok Pandabuy Spreadsheet Finds',
    excerpt: 'Items that blew up on TikTok and where to find them on the pandabuy spreadsheet. Stay ahead of viral trends.',
    date: 'July 3, 2026',
    readTime: '4 min read',
    image: 'https://readdy.ai/api/search-image?query=Trending%20viral%20fashion%20items%20arranged%20in%20stylish%20flat%20lay%20with%20soft%20LED%20glow%20social%20media%20aesthetic%20warm%20tones%20editorial%20product%20photography%20popular%20items%20on%20warm%20linen%20surface%20clean%20modern%20composition%20high%20detail&width=800&height=500&seq=blog-thumb-viral-2026&orientation=landscape',
    tag: 'Viral',
    featured: false,
  },
  {
    slug: 'pandabuy-spreadsheet-beginner-guide',
    title: 'Pandabuy Spreadsheet Beginner Guide',
    excerpt: 'New to pandabuy? This step-by-step beginner guide walks you through using the spreadsheet for your first haul.',
    date: 'July 5, 2026',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=Open%20laptop%20displaying%20online%20shopping%20interface%20next%20to%20notebook%20with%20pen%20and%20coffee%20cup%20on%20clean%20wooden%20desk%20beginner%20guide%20aesthetic%20warm%20natural%20lighting%20cozy%20workspace%20photography%20warm%20neutral%20tones%20organized%20workspace&width=800&height=500&seq=blog-thumb-beginner-2026&orientation=landscape',
    tag: 'Beginner',
    featured: false,
  },
  {
    slug: 'haul-tips-pandabuy-spreadsheet',
    title: 'Haul Tips and Tricks Pandabuy Spreadsheet',
    excerpt: 'Expert strategies for building efficient hauls. Shipping tips, weight optimization, and avoiding customs delays.',
    date: 'July 8, 2026',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20box%20partially%20opened%20revealing%20neatly%20folded%20clothes%20inside%20packing%20materials%20visible%20warm%20natural%20lighting%20unboxing%20photography%20warm%20neutral%20tones%20delivery%20and%20logistics%20aesthetic%20clean%20composition&width=800&height=500&seq=blog-thumb-hauls-2026&orientation=landscape',
    tag: 'Tips',
    featured: false,
  },
  {
    slug: 'pandabuy-shopping-guide-2026',
    title: 'Pandabuy Shopping Guide 2026',
    excerpt: 'Your comprehensive shopping guide for navigating pandabuy. Agent selection, payment methods, and safety tips.',
    date: 'July 10, 2026',
    readTime: '7 min read',
    image: 'https://readdy.ai/api/search-image?query=Shopping%20checklist%20notebook%20with%20elegant%20pen%20and%20small%20paper%20shopping%20bags%20on%20warm%20wooden%20desk%20natural%20lighting%20editorial%20lifestyle%20photography%20warm%20cream%20tones%20organized%20planning%20aesthetic%20minimal%20composition%20clean%20workspace&width=800&height=500&seq=blog-thumb-shopping-2026&orientation=landscape',
    tag: 'Guide',
    featured: false,
  },
];